import { ArrowRight, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TrustedMarinePerformanceHero() {
  return <section data-section-id="253287" id="trusted-marine-performance-hero" className="relative overflow-hidden dark bg-background py-24 sm:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none">
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_20%,transparent_100%)] opacity-10" />
        
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-primary/20 blur-[120px] rounded-lg animate-pulse" />
        
        {}
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686328/img/marine_wave_graphic.png" alt="Marine Wave" className="absolute bottom-0 right-0 w-full h-full object-cover opacity-20 mix-blend-overlay" />
      </div>

      <div className="container relative z-10 mx-auto px-4 text-center">
        {}
        <div className="inline-flex items-center rounded-md border border-border bg-background/40 px-4 py-1.5 text-sm font-medium text-primary backdrop-blur-sm mb-8 shadow-sm">
          <BookOpen className="mr-2 h-4 w-4 text-primary" />
          <span className="tracking-widest uppercase font-mono">Japanese OEM Standards</span>
        </div>

        {}
        <h1 className="font-default text-5xl font-bold tracking-tighter sm:text-6xl lg:text-8xl mb-6 max-w-4xl mx-auto text-foreground uppercase">
          ALTTAI{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-secondary to-primary bg-[length:200%_auto] animate-[pulse_4s_ease-in-out_infinite]">
            MARINE
          </span>
        </h1>

        {}
        <p className="mx-auto max-w-2xl text-lg sm:text-xl text-muted-foreground mb-10 leading-relaxed font-default tracking-widest uppercase opacity-90">
          Trusted Marine Performance. Premium spare parts engineered for reliability and compatible with Yamaha outboards.
        </p>

        {}
        <div className="flex flex-col sm:flex-row justify-center gap-4 items-center">
          <Button asChild size="lg" className="rounded-md px-8 h-14 text-base w-full sm:w-auto shadow-lg bg-primary hover:bg-secondary hover:text-primary transition-colors">
            <Link to="/ProductsPage">
              Explore Products <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="rounded-md px-8 h-14 text-base w-full sm:w-auto bg-transparent backdrop-blur-sm border-primary text-primary hover:bg-primary hover:text-primary-foreground">
            <Link to="/RequestQuotationPage">
              Request Quote
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}